import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Controller, useForm } from "react-hook-form";

const EditPage = ({ setConnection }) => {
  const { handleSubmit, control, reset, getValues, setValue } = useForm({
    defaultValues: {
      connName: "",
      connApiName: "",
    },
  });
  return (
    <Box p={5}>
      <Box>
        <Box display="flex" alignItems="center">
          <ArrowBackIosIcon
            sx={{
              color: "#757575",
              "&:hover": { color: "black" },
              mt: "5px", // Adjusts the vertical alignment of the icon
            }}
            onClick={() => setConnection((prev) => "details")}
          />
          <Typography sx={{ fontWeight: "bold", fontSize: "16px", ml: 1 }}>
            Edit Connection
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: "12px",
              color: "text.secondary",
              width: "98%",
              paddingLeft: "30px",
            }}
          >
            Make the necessary changes to the connection details and click
            'Update'. Updating will revoke the connection.
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ mb: 4, mt: 4 }} />

      <Typography mb={6} sx={{ fontWeight: "bold" }}>
        Connection Details
      </Typography>

      <form onSubmit={handleSubmit()}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
            <Typography sx={{ marginBottom: "8px", fontSize: "15px" }}>
              Connection Name
            </Typography>
            <Controller
              name="connName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    size="small"
                    id="standard-basic"
                    label="Enter Connection Name"
                    variant="outlined"
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Typography sx={{ marginBottom: "8px", fontSize: "15px" }}>
              Connection Link Name
            </Typography>

            <Controller
              name="connApiName"
              control={control}
              // disabled
              rules={{ required: true }}
              render={({ field }) => (
                <>
                  <TextField
                    size="small"
                    id="standard-basic"
                    variant="outlined"
                    label="Enter Connection Name"
                    {...field}
                    onChange={(event) => {
                      field.onChange(event?.target?.value);
                    }}
                    fullWidth
                  />
                </>
              )}
            />
          </Grid>
        </Grid>
        <Box pt={25} sx={{ display: "flex" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              marginTop: "10px",
              bgcolor: "#1976D2",
              textTransform: "none",
            }}
          >
            Update
          </Button>
          <Button
            type="submit"
            variant="outlined"
            sx={{
              // color: "#757575",
              // bgcolor: "#eeeeee",
              marginTop: "10px",
              marginLeft: "20px",
              mr: 2,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default EditPage;
